import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';


/**
 * Connect new domain to user
 * */
export function* connectNewDomainToUser(data) {
    const response = yield call(api.connectNewDomainToUser, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.CONNECT_NEW_DOMAIN_TO_USER.SUCCESS,
            data: response,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data && response.data.message,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 5,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.CONNECT_NEW_DOMAIN_TO_USER.FAILURE,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Failed',
            message: response.data && response.data.errors && response.data.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 999,
        },
    });

    return response;
}

export function* watchConnectNewDomainToUser() {
    while (true) {
        const { data } = yield take(actionTypes.CONNECT_NEW_DOMAIN_TO_USER.REQUEST);
        yield fork(connectNewDomainToUser, data);
    }
}

/**
 * DELETE_DOMAIN
 * */
export function* deleteDomain(data) {
    const response = yield call(api.deleteDomain, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_DOMAIN.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data && response.data.message,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 5,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.DELETE_DOMAIN.FAILURE,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Failed',
            message: response.data && response.data.errors && response.data.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 999,
        },
    });

    return response;
}

export function* watchDeleteDomain() {
    while (true) {
        const { data } = yield take(actionTypes.DELETE_DOMAIN.REQUEST);
        yield fork(deleteDomain, data);
    }
}

/**
 * DELETE_DOMAIN
 * */
export function* getListDomain() {
    const response = yield call(api.getListDomain);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_LIST_DOMAIN.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_LIST_DOMAIN.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetListDomain() {
    while (true) {
        yield take(actionTypes.GET_LIST_DOMAIN.REQUEST);
        yield fork(getListDomain);
    }
}


export default [
    watchConnectNewDomainToUser,
    watchDeleteDomain,
    watchGetListDomain,
];



// WEBPACK FOOTER //
// ./app/sagas/domains.js